import { useState, useEffect, useRef } from 'react';
import { useJsApiLoader, GoogleMap, Marker } from '@react-google-maps/api';
import { Box, CircularProgress, Typography } from '@mui/material';

const containerStyle = {
  width: '100%',
  aspectRatio: '16 / 9',
  minHeight: 300,
  borderRadius: 8,
  overflow: 'hidden',
};

const mapOptions = {
  zoomControl: true,
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  gestureHandling: 'cooperative',
};

function SimpleMap({ address }) {
  const [center, setCenter] = useState(null);
  const [error, setError] = useState(null);
  const geocoderRef = useRef(null);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  useEffect(() => {
    if (!isLoaded || !address || !window.google) return;

    if (!geocoderRef.current) {
      geocoderRef.current = new window.google.maps.Geocoder();
    }

    geocoderRef.current.geocode({ address }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const loc = results[0].geometry.location;
        setCenter({ lat: loc.lat(), lng: loc.lng() });
      } else {
        setError(`No se pudo encontrar la ubicaci\u00f3n: ${address}`);
      }
    });
  }, [isLoaded, address]);

  if (loadError) {
    return (
      <Box sx={{ p: 3, bgcolor: '#f5f5f5', borderRadius: 2, textAlign: 'center' }}>
        <Typography color="error" variant="body2">
          Error al cargar Google Maps
        </Typography>
      </Box>
    );
  }

  if (!isLoaded) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300, bgcolor: '#f5f5f5', borderRadius: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !center) {
    return (
      <Box sx={{ p: 3, bgcolor: '#f5f5f5', borderRadius: 2, textAlign: 'center' }}>
        <Typography color="text.secondary" variant="body2">
          {error || 'Direcci\u00f3n no disponible'}
        </Typography>
      </Box>
    );
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={15}
      options={mapOptions}
    >
      <Marker position={center} />
    </GoogleMap>
  );
}

export default SimpleMap;
